import { isMetric, isNumericItem, isTableCalculation, } from '@lightdash/common';
/** Metrics first, then table calculations, then everything else. */
export const getGaugeItemPriority = (item) => {
    if (isMetric(item)) {
        return 1;
    }
    if (isTableCalculation(item)) {
        return 2;
    }
    return 3;
};
/** The numeric items a gauge can plot, metrics first. */
export const getAvailableGaugeFieldIds = (itemsMap) => {
    // Keyed by the map's own ids: a field's id is where it sits in the map.
    const numericItems = Object.entries(itemsMap || {}).filter(([, item]) => isNumericItem(item));
    const itemsSortedByType = numericItems.sort(([, a], [, b]) => getGaugeItemPriority(a) - getGaugeItemPriority(b));
    return itemsSortedByType.map(([fieldId]) => fieldId);
};
// Get the effective selected field - use state value or fallback to first available
export const getEffectiveGaugeSelectedField = (selectedField, availableFieldsIds) => {
    if (selectedField)
        return selectedField;
    return availableFieldsIds.length > 0 ? availableFieldsIds[0] : undefined;
};
/**
 * Resolves a saved gauge config against the query's items, the way the
 * explorer does when it first mounts a chart: fills in the defaults and
 * picks the first numeric field when none is selected.
 *
 * The frontend's `useGaugeChartConfig` holds the same values as editor
 * state; this is the one-shot equivalent for headless rendering.
 */
export const resolveGaugeChartConfig = ({ chartConfig: initialChartConfig, itemsMap, }) => {
    const availableFieldsIds = getAvailableGaugeFieldIds(itemsMap);
    return {
        selectedField: getEffectiveGaugeSelectedField(initialChartConfig?.selectedField, availableFieldsIds),
        min: initialChartConfig?.min ?? 0,
        max: initialChartConfig?.max ?? 100,
        maxFieldId: initialChartConfig?.maxFieldId,
        showAxisLabels: initialChartConfig?.showAxisLabels ?? false,
        sections: initialChartConfig?.sections ?? [],
        customLabel: initialChartConfig?.customLabel,
        showPercentage: initialChartConfig?.showPercentage ?? false,
        customPercentageLabel: initialChartConfig?.customPercentageLabel,
    };
};
